export const iconFontAwesomeDesignPaste = (
	<i className="fa-solid fa-paste"></i>
);
